import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'radius-top-left', 'RadiusTopLeft', [["path",{"d":"M5 19v-6a8 8 0 0 1 8 -8h6"}]]);